<template>
  <div class="about">
    <h1>This is an about page</h1>
    <p>这是掌上温岭app里的扩展程序</p>
    <div>
      {{ info }}
    </div>

    <van-cell-group v-if="!showBtns">
      <van-field
        v-model="password"
        label=""
        type="password"
        placeholder="请输入通关密语"
        v-on:keyup.enter="doSubmit"
      />
    </van-cell-group>

    <div v-else>
      <van-cell-group>
        <van-button @click="getUserInfo">getUserInfo</van-button>
        <van-button @click="ensureBackendLogin">backendLogin</van-button>
        <van-button @click="refreshBackendToken">refreshToken</van-button>
        <van-button @click="decodeStoredToken">decodeToken (view only)</van-button>
        <van-button @click="doClearStorage">clearStorage</van-button>
        <van-button to="product/list">productList</van-button>
        <van-button @click="doClosePage">close page</van-button>
        <van-button type="info" @click="doRefresh">刷新</van-button>
      </van-cell-group>

      <div>
        <van-field v-model.trim="debugMobile" type="tel" label="模拟账号" maxlength="11" placeholder="请输入用户手机号码" />
        <van-button type="primary" :loading="simulatingLogin" @click="simulateAppLogin">模拟掌上温岭登录</van-button>
        <div>{{ showText }}</div>
        <van-field
          v-model="mobile"
          center
          clearable
          label="手机号码"
          placeholder="请输入手机号码"
        >
          <template #button>
            <van-button size="small" type="primary" @click="doFindByMobile"
              >提交</van-button
            >
          </template>
        </van-field>
      </div>
    </div>
  </div>
</template>

<script>
import { login, findByMobile, checkAccount } from "@/api/api";
import { createDebugAppSession, decodeAccessTokenPayload, ensureAppSession, forceRefreshAccessToken } from "@/utils/appAuth";
import storage from "@/utils/storage";

export default {
  name: "About",
  data() {
    return {
      showBtns: true,
      password: "",
      token: storage.get("token") || "",
      showText: "",
      debugMobile: "",
      simulatingLogin: false,
      info: null,
      mobile: "",
    };
  },
  methods: {
    doRefresh(){
      window.location.reload();
    },
    doClosePage(){
// window.opener=null;
// window.open("about:blank", "_top").close()
console.log(8888);
CP.closePage({
    completed: function(data){
        CP.tools.writelog('close_page', data);
    },
    cpIncompatible: function () {
         CP.tools.writelog('', '此环境不支持此方法');
    }
});
    },
    doFindByMobile() {
      findByMobile({ mobile: this.mobile })
        .then((res) => {
          console.log(res);
        })
        .error((err) => {
          console.log(err);
        });
    },
    doSubmit() {
      if (this.password == "wlrbnm") {
        this.showBtns = true;
      }
    },
    doClearStorage() {
      this.$storage.clear();
    },
    decodeStoredToken() {
      this.token = storage.get("token") || "";
      this.showText = decodeAccessTokenPayload(this.token) || "Token cannot be decoded";
    },
    async ensureBackendLogin() {
      const appUser = storage.get("appUser");
      if (!appUser || !appUser.account_id || !storage.get("uniqueId")) {
        this.$toast.fail("未获取到掌上温岭登录会话");
        return;
      }
      try {
        const result = await ensureAppSession(appUser);
        this.token = result.token;
        this.showText = decodeAccessTokenPayload(result.token);
      } catch (error) {
        this.$toast.fail(error.message || "登录失败");
      }
    },
    async refreshBackendToken() {
      try {
        const token = await forceRefreshAccessToken();
        if (!token) throw new Error("没有可用的登录会话");
        this.token = token;
        this.showText = decodeAccessTokenPayload(token);
      } catch (error) {
        this.$toast.fail(error.message || "刷新失败");
      }
    },
    async simulateAppLogin() {
      const mobile = String(this.debugMobile || "").trim();
      if (!/^1[3-9]\d{9}$/.test(mobile)) {
        this.$toast.fail("请输入正确的手机号码");
        return;
      }
      this.simulatingLogin = true;
      try {
        const authState = await createDebugAppSession(mobile);
        const accountResult = await checkAccount();
        if (accountResult.code !== 1 || !accountResult.data || !accountResult.data.exist) {
          throw new Error(accountResult.msg || "未找到模拟用户");
        }
        storage.set("hasUser", true);
        storage.set("zswlUser", accountResult.data.user);
        this.token = authState.token;
        this.showText = decodeAccessTokenPayload(authState.token);
        this.$toast.success("模拟登录成功");
      } catch (error) {
        this.$toast.fail(error.message || "模拟登录失败");
      } finally {
        this.simulatingLogin = false;
      }
    },
    getUserInfo() {
      login({ app_user: storage.get("appUser") });
    },
  },
};
</script>
